import { gql } from 'graphql-request';
import {
  AssetFieldFilterOptions,
  TestExecutionFieldFilterOptions,
} from '@elementary/common-ui/services/gql/types';

export const getLineageAssetsFilterOptionsQuery = gql`
  query GetLineageAssetsFilterOptions {
    assetsFilterOptions {
      field
      options {
        value
        count
      }
    }
  }
`;

export const getLineageTestFilterOptionsQuery = gql`
  query GetLineageTestFilterOptions {
    latestTestExecutionsFilterOptions(filters: { includeDeleted: false }) {
      field
      options {
        value
        count
      }
    }
  }
`;

export type LineageAssetsFilterOptionsResponse = {
  assetsFilterOptions: AssetFieldFilterOptions[];
};

export type LineageTestFilterOptionsResponse = {
  latestTestExecutionsFilterOptions: TestExecutionFieldFilterOptions[];
};
